module.exports = __webpack_public_path__ + "static/media/assur_auto_image_principale.ef41ac2d.webp";